__webpack_require__.p = "https://hbg-fed-static-prd.hbfile.net/v4/microapps-double-invite-retail/";